import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import store from '@/store';
import { getOS } from '../utils/getOS';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/user/Login.vue'),
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('../views/user/Logout'),
  },
  {
    path: '/challenge-main',
    name: 'challengeMain',
    component: () => import('../views/challenge/ChallengeMain.vue'),
  },
  {
    path: '/surveys',
    name: 'surveys',
    component: () => import('../views/surveys/surveys.vue'),
  },
  {
    path: '/challenge-description',
    name: 'challengeDescription',
    component: () => import('../views/challenge/ChallengeDescription.vue'),
  },
  {
    path: '/challenge-select-child',
    name: 'challengeSelectChild',
    component: () => import('../views/challenge/ChallengeSelectChild.vue'),
  },
  {
    path: '/challenge-parent-approve/:childId',
    name: 'challengeParentApprove',
    component: () => import('@/views/challenge/parent/views/ChallengeParentApprove.vue'),
  },
  {
    path: '/challenge-child-approve',
    name: 'challengeChildApprove',
    component: () => import('../views/challenge/ChallengeChildApprove.vue'),
  },
  {
    path: '/congrats',
    name: 'Congrats',
    component: () => import('../views/general/Congrats.vue'),
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/general/Settings.vue'),
  },
  {
    path: '/help-main',
    name: 'HelpMain',
    component: () => import('../views/help/HelpMain.vue'),
  },
  {
    path: '/help-select-cause',
    name: 'HelpSelectCause',
    component: () => import('../views/help/HelpSelectCause.vue'),
  },
  {
    path: '/help-select-change',
    name: 'HelpSelectChange',
    component: () => import('../views/help/HelpSelectChange.vue'),
  },
  {
    path: '/help-select-cause/:Mid',
    name: 'HelpSelectCauseId',
    component: () => import('../views/help/HelpSelectCause.vue'),
  },
  {
    path: '/help-saved-solving',
    name: 'HelpSavedSolving',
    component: () => import('../views/help/HelpSavedSolving.vue'),
  },
  {
    path: '/help-detail-solving',
    name: 'HelpDetailSolving',
    component: () => import('../views/help/HelpDetailSolving.vue'),
  },
  {
    path: '/help-description',
    name: 'HelpDescription',
    component: () => import('../views/help/HelpDescription.vue'),
  },
  {
    path: '/help-quick-tips/:Mid',
    name: 'HelpQuickTipsId',
    component: () => import('../views/help/HelpQuickTips.vue'),
  },
  {
    path: '/help-quick-skill',
    name: 'HelpQuickSkill',
    component: () => import('../views/help/HelpQuickSkill.vue'),
  },
  {
    path: '/parent-goals',
    name: 'PlanMain',
    component: () => import('../views/goal/GoalParents.vue'),
  },
  {
    path: '/plan-select-skill',
    name: 'PlanSelectSkill',
    component: () => import('../views/planning/PlanSelectSkill.vue'),
  },
  {
    path: '/skill-description/:Mid',
    name: 'PlanDescription',
    component: () => import('../views/planning/PlanDescription.vue'),
  },
  {
    path: '/skill-planning/:Mid',
    name: 'PlanPlanning',
    component: () => import('../views/planning/PlanPlanning.vue'),
  },
  {
    path: '/skill-practice/:Mid',
    name: 'PlanPractice',
    component: () => import('../views/planning/PlanPractice.vue'),
  },
  {
    path: '/skill-rate/:Mid',
    name: 'PlanRate',
    component: () => import('../views/planning/PlanRate.vue'),
  },
  {
    path: '/progress',
    name: 'Progress',
    component: () => import('../views/progress/progress.vue'),
  },
  {
    path: '/rewards',
    name: 'Rewards',
    component: () => import('../views/rewards/Rewards.vue'),
  },
  {
    path: '/rewards-ideas',
    name: 'RewardsIdeas',
    component: () => import('../views/rewards/RewardsBankIdeas.vue'),
  },
  {
    path: '/badges',
    name: 'Badges',
    component: () => import('../views/badges/Badges.vue'),
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('../views/general/Settings.vue'),
  },
  {
    path: '/settings/clinicians',
    name: 'cliniciansReport',
    component: () => import('../views/general/ClinicianReport.vue'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/general/About.vue'),
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: () => import('../views/general/Faq.vue'),
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: () => import('../views/general/Notifications.vue'),
  },
  {
    path: '/update-select-child',
    name: 'UpdateSelectChild',
    component: () => import('../views/general/UpdateSelectChild.vue'),
  },
  {
    path: '/register-child',
    name: 'RegisterChild',
    component: () => import('../views/general/RegisterChild.vue'),
  },
  {
    path: '/register-child/:childId',
    name: 'RegisterChilds',
    component: () => import('../views/general/RegisterChild.vue'),
  },
  { path: '*', component: () => import('@/views/general/Error404') },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

const loadData = async () => {
  const userId = store.getters['user/getUserId'];
  const userIsAParent = store.getters['user/userIsAParent'];

  if (userIsAParent) {
    await store.dispatch('parent/FetchChildrenData', userId);
  } else {
    await store.dispatch('user/getUserData', { userIsAParent, userId });
  }
};

router.beforeEach(async (to, from, next) => {
  try {
    const isLogged = store.getters['user/getUserIsLogged'];
    const isLoginPath = to.name === 'Login';
    store.commit('general/setIsCharging', true);

    if (isLoginPath) {
      next();
    } else if (!isLogged) {
      next({ name: 'Login' });
    } else {
      const route = to.path;
      const device = getOS();
      const userId = store.getters['user/getUserIdUnique'];

      await loadData();
      await store.dispatch('general/setSession', { route, device, userId });
      next();
    }
  } catch (error) {
    console.error(`Failed navigation to ${to.name}`);
    next(false);
  }
});

router.afterEach(() => {
  store.commit('general/setIsCharging', false);
});

export default router;
